import React from 'react';
import PropTypes from 'prop-types';
import { Column, Icon, List, Row, Badge } from '@pella/sash-framework';
import { CTA } from '../../../';

const MegaMenu = ({ data }) => {
	if (!data) return null;

	return (
		<div className={`megaMenu invisible absolute -left-36 overflow-hidden rounded border border-gray-10 bg-white opacity-0 shadow-[0_4px_8px_rgba(37,55,126,0.2)] transition-opacity group-focus-within:visible group-focus-within:opacity-100 group-hover:visible group-hover:opacity-100 xl:-left-16`}>
			<div className='grid grid-flow-col gap-x-16 px-10 pt-6 xl:gap-x-28'>
				{data.sortable?.[0] &&
					data.sortable.map((col, index) => (
						<div
							key={index}
							className='flex w-[428px] flex-col xl:w-[448px]'
						>
							{col.heading && <p className='megaMenu-heading mb-5 border-b border-b-gray-10 pb-3 text-2xl font-semibold !leading-snug'>{col.heading}</p>}
							{col.by_type?.[0] && (
								<Row
									noPadding
									className='gap-x-5 pb-12 xl:gap-x-10'
								>
									{col.by_type.map((links, index) => (
										<Column
											xs='auto'
											key={index}
										>
											{links.heading && <p className='megaMenu-typeHeading mb-3 text-base capitalize !leading-snug text-gray-50'>{links.heading}</p>}

											{links.ctas?.[0] && (
												<List
													bullets='none'
													className='space-y-3'
												>
													{links.ctas.map((cta, index) => (
														<li key={index}>
															<CTA
																data={cta.cta[0]}
																className='flex items-center rounded-sm no-underline transition-colors hover:bg-[rgba(0,130,62,0.1)] focus:bg-[rgba(0,130,62,0.1)] active:bg-primary active:text-white'
															>
																<span className='font-semibold'>{cta.cta[0].cta_title}</span>
																{cta.flag && (
																	<Badge
																		color='light-gray'
																		style={{ backgroundColor: cta.flag_hex_value, color: cta.text_hex_value }}
																		variant='pill'
																		className='ml-2 !text-xs !font-normal'
																		size='sm'
																	>
																		{cta.material_symbol && (
																			<Icon
																				size={10}
																				className='mr-1'
																				name={cta.material_symbol}
																			/>
																		)}
																		{cta.flag}
																	</Badge>
																)}
															</CTA>
														</li>
													))}
												</List>
											)}
										</Column>
									))}
								</Row>
							)}

							{col.cta?.[0] && (
								<div className='mt-auto border-t border-t-gray-10 pb-4 pt-2'>
									<CTA data={col.cta[0]} />
								</div>
							)}
						</div>
					))}
			</div>

			{data.cta?.[0] && (
				<CTA
					data={data.cta[0]}
					renderAs='link'
					className='megaMenu-cta group flex items-center bg-primary px-12 py-2 font-semibold text-white [&>span]:hover:!no-underline'
				>
					<span className='underline decoration-white decoration-1'>{data.cta[0].cta_title}</span>
					<Icon
						name='arrow_forward'
						size={16}
						className='ml-2'
					/>
				</CTA>
			)}
		</div>
	);
};

MegaMenu.propTypes = {
	data: PropTypes.object,
};

export default MegaMenu;
